<template>
    <span
        ref="input"
        class="amInput"
        :contenteditable="true"
        @blur="onBlur"
    />
</template>

<script>
import { stripHtml } from '@/utils/clipboard';

export default {
    name: 'tween-input-text',

    props: {
        prop: {
            type: String,
            required: true,
        },

        value: {
            type: String,
            default: '',
        },
    },

    mounted() {
        this.elem = this.$refs.input;
        this.elem.innerText = this.value;
        this.elem.addEventListener('paste', stripHtml);
    },

    destroyed() {
        this.elem.removeEventListener('paste', stripHtml);
    },

    methods: {
        onBlur() {
            let valueNew = this.elem.innerText;

            if (this.prop === 'boxShadow') {
                valueNew = this.fixBoxShadow(valueNew);
            }

            this.$emit('input', valueNew);
        },

        // typically box shadows have the color value at the end - e.g. "0 0 5px 5px #222"
        // ... however GSAP does not animate this properly unless the color is at the beginning - e.g. "#222 0 0 5px 5px"
        fixBoxShadow(value) {
            // check for hex or rgba values
            let colorStartPos = value.indexOf(' #') >= 0
                ? value.indexOf(' #')
                : value.indexOf(' rgb');

            // if none are found, check for literal color strings, e.g. "red" or "white"
            if (colorStartPos <= 0) {
                const lastSpacePos = value.lastIndexOf(' ');
                const lastKeyword = value.slice(lastSpacePos + 1);

                if (lastKeyword.match(/^[a-zA-Z]+$/)) {
                    colorStartPos = lastSpacePos;
                }
            }

            // if the input is invalid, or missing the color, or already has the color at the beginning - leave it as-is
            if (colorStartPos <= 0) return value;

            const nextParensPos = value.indexOf(')', colorStartPos + 1);
            const nextSpacePos = value.indexOf(' ', colorStartPos + 1);

            // we need to know where the color substring ends
            // we set the end position to the length of the input value by default
            let colorEndPos = value.length;

            if (nextParensPos !== -1) {
                // next we check for a ")" first in case its an rgba value
                colorEndPos = nextParensPos + 1;
            } else if (nextSpacePos !== -1) {
                // we also check for a space in case the user left spaces at the end of the string, e.g. "0 0 5px 5px #222 "
                colorEndPos = nextSpacePos;
            }

            const color = `${ value.slice(colorStartPos + 1, colorEndPos) } `;

            value = value.split('');
            value.splice(colorStartPos, colorEndPos);
            value.unshift(color);
            value = value.join('');

            return value;
        },
    },
};
</script>

<style lang="scss" scoped>
.amInput {
    @extend %input-display;
    min-width: $tween-input-width;
    font-weight: 600;
    border-color: var(--app-borderColor);
}
</style>
